import { render, staticRenderFns } from "./ChainModule.vue?vue&type=template&id=65e66b62&scoped=true&lang=pug&"
import script from "./ChainModule.vue?vue&type=script&lang=js&"
export * from "./ChainModule.vue?vue&type=script&lang=js&"
import style0 from "./ChainModule.vue?vue&type=style&index=0&id=65e66b62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e66b62",
  null
  
)

export default component.exports